import React from 'react';
import { observer, useAsObservableSource } from 'mobx-react-lite';
import { useAppStateContext } from '../../../AppState/AppState';
import { WelcomeBonus, PromoName, PromoInfoWrapper, ActionsWrapper } from './WelcomeBonusItem.style';
import moment from 'moment';
import { computed, observable, makeAutoObservable } from 'mobx';
import { WelcomeBonusType, WelcomeBonusState } from 'src/AppState/WelcomeBonusState/WelcomeBonusState';
import { TrashIconWrapper } from 'src/components/PromoCodes/PromoCodesListItem/PromoCodesItem.style';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { ListItem } from 'src/domains/layouts/shared/cms/list/List.style';
import { StatusLabel } from 'src/domains/layouts/shared/labels/StatusLabel';

interface WelcomeBonusPropsType {
    welcomeBonus: WelcomeBonusType;
}

class State {
    @observable copySuccess = false;
    @observable isShowImages = false;
    constructor(
        private readonly welcomeBonusState: WelcomeBonusState,
        private readonly welcomeBonus: WelcomeBonusType
    ) {
        makeAutoObservable(this);
    }

    @computed public get isInactive(): boolean | null {
        if (
            this.welcomeBonus.validUntil === null ||
            this.welcomeBonus.validUntil === undefined ||
            this.welcomeBonus.validUntil === ''
        ) {
            return null;
        }
        const endDate = moment(this.welcomeBonus.validUntil);
        const currentDate = moment();
        const isDateBefore = moment(endDate).isBefore(currentDate);

        return isDateBefore;
    }

    onChangeWelcomeBonusToEdit = (): void => {
        this.welcomeBonusState.setPage('edit');
        this.welcomeBonusState.setEditedWelcomeBonus(this.welcomeBonus);
    };

    onRemove = (): void => {
        this.welcomeBonusState.onRemove(this.welcomeBonus);
    };

    setButtonText = (isInvalid: boolean | null): string => {
        if (isInvalid === null) {
            return `Valid for ${this.welcomeBonus.validFor} day(s)`;
        } else if (isInvalid) {
            return 'Inactive';
        }

        return 'Active';
    };
}

export const WelcomeBonusListItem = observer(({ welcomeBonus }: WelcomeBonusPropsType) => {
    const { welcomeBonusState } = useAppStateContext();
    const welcomeBonusObservable = useAsObservableSource(welcomeBonus);
    const [state] = React.useState(() => new State(welcomeBonusState, welcomeBonusObservable));
    const isEdited = welcomeBonus.id === welcomeBonusState.editedWelcomeBonusElement?.id;
    const status = state.isInactive === null ? 'info' : state.isInactive ? 'ended' : 'live';

    return (
        <ListItem
            isEdited={isEdited}
            homepage={false}
            boxHeight='56px'
            direction='row'
        >
            <PromoInfoWrapper>
                <PromoName>{welcomeBonus.promotionCode}</PromoName>

                <WelcomeBonus>{welcomeBonus.name}</WelcomeBonus>
            </PromoInfoWrapper>

            <ActionsWrapper>
                <StatusLabel status={status}>{state.setButtonText(state.isInactive)}</StatusLabel>
                <Button
                    version='secondary'
                    size='small'
                    onClick={state.onChangeWelcomeBonusToEdit}
                >
                    Edit
                </Button>
                <TrashIconWrapper onClick={state.onRemove} />
            </ActionsWrapper>
        </ListItem>
    );
});
